/* ============================================================
   somnair-ox.js — famille "Onyx" (zone ox)

   Deux comportements, rien de plus :
     1. galerie : miniature cliquee -> media principal ;
     2. paliers de quantite : radio cochee -> input[name=quantity] + bascule
        des blocs [data-smx-tiershow].

   REGLE : ce fichier ne FORMATE JAMAIS un prix. Le produit est mono-variante,
   les trois totaux (1 / 2 / 3 unites, remises -0 / -10 / -20 %) sont pre-rendus
   en Liquid en arithmetique entiere sur des centimes. Le JS ne fait que montrer
   le bon bloc. C'est ce qui garantit que « prix affiche == prix facture », la
   remise etant appliquee au checkout par deux discounts automatiques natifs
   (voir api/43_set_onyx_volume_discounts.py).
   ============================================================ */
(function () {
  'use strict';

  function initTiers(root) {
    var qtyInput = root.querySelector('[data-smx-qty]');
    var radios = root.querySelectorAll('[data-smx-tier]');
    if (!radios.length) return;

    function apply(qty) {
      if (qtyInput) qtyInput.value = qty;
      root.querySelectorAll('[data-smx-tiershow]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-smx-tiershow') === String(qty));
      });
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) apply(r.getAttribute('data-qty') || '1');
      });
    });

    var checked = root.querySelector('[data-smx-tier]:checked') || radios[0];
    if (checked) {
      checked.checked = true;
      apply(checked.getAttribute('data-qty') || '1');
    }
  }

  function initGallery(root) {
    var stage = root.querySelector('[data-smx-stage]');
    var thumbs = root.querySelectorAll('[data-smx-thumb]');
    if (!stage || !thumbs.length) return;
    var slides = stage.querySelectorAll('[data-smx-slide]');

    function show(index) {
      slides.forEach(function (s) {
        var on = s.getAttribute('data-smx-slide') === String(index);
        s.classList.toggle('is-active', on);
        // une video qui defile hors champ continuerait a jouer dans le vide
        if (!on) {
          var v = s.querySelector('video');
          if (v && !v.paused) v.pause();
        }
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-smx-thumb') === String(index));
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.getAttribute('data-smx-thumb')); });
    });
    show(thumbs[0].getAttribute('data-smx-thumb'));
  }

  function boot() {
    document.querySelectorAll('[data-smx-buy]').forEach(initTiers);
    document.querySelectorAll('[data-smx-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Le theme editor re-rend une section sans recharger la page.
  document.addEventListener('shopify:section:load', boot);
})();
